var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-index-container" },
    [
      _c(
        "el-card",
        { staticClass: "header-container" },
        [
          _c(
            "el-row",
            {
              staticStyle: { height: "50px" },
              attrs: { align: "middle", type: "flex", gutter: 5 },
            },
            [
              _c("i", {
                staticClass: "el-icon-back",
                on: {
                  click: function ($event) {
                    return _vm.$router.back(-1)
                  },
                },
              }),
              _c("img", {
                staticClass: "header-logo",
                attrs: { src: require("@/assets/images/logo-blue.png") },
                on: {
                  click: function ($event) {
                    return _vm.$router.push({ path: "/home" })
                  },
                },
              }),
              _c("h2", { staticClass: "header-title" }, [
                _vm._v(_vm._s(_vm.formTitle)),
              ]),
              _c("el-col"),
              _vm.formPermissionState.canEdit
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["publish_publish"],
                          expression: "['publish_publish']",
                        },
                      ],
                      attrs: { type: "primary", disabled: _vm.formStatus != 2 },
                      on: { click: _vm.handlePublish },
                    },
                    [_vm._v(" 更新 ")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-view" },
                  on: { click: _vm.openPreviewHandle },
                },
                [_vm._v(" 预览 ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", plain: "" },
                  on: { click: _vm.getReleaseHistory },
                },
                [_vm._v(" 查看发布记录 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.permissionReady &&
      _vm.formPermissionState.canEdit &&
      _vm.formStatus == 2
        ? _c("el-alert", {
            staticClass: "custom_alert",
            attrs: {
              title:
                "您正在编辑此问卷，在更新之前，您所做的更改将不会应用到正式答题",
              type: "warning",
              center: "",
              "show-icon": "",
            },
          })
        : _vm._e(),
      _c("div", { staticClass: "main-container" }, [
        _c(
          "div",
          { staticClass: "left-menu-wrap" },
          [
            _vm.permissionReady
              ? _c(
                  "el-menu",
                  {
                    staticClass: "el-menu-vertical",
                    attrs: {
                      collapse: _vm.isCollapse,
                      "default-active": _vm.defaultActiveMenu,
                    },
                    on: { select: _vm.menuSelectHandle },
                  },
                  _vm._l(_vm.getNavTree, function (menuItem) {
                    return _c(
                      "el-menu-item",
                      { key: menuItem.menuId, attrs: { index: menuItem.path } },
                      [
                        _c("i", { class: menuItem.icon }),
                        _c(
                          "span",
                          { attrs: { slot: "title" }, slot: "title" },
                          [_vm._v(_vm._s(menuItem.name))]
                        ),
                      ]
                    )
                  }),
                  1
                )
              : _vm._e(),
            !_vm.isCollapse
              ? _c("i", {
                  staticClass: "el-icon-d-arrow-left",
                  on: { click: _vm.collapseHandle },
                })
              : _c("i", {
                  staticClass: "el-icon-d-arrow-right",
                  on: { click: _vm.collapseHandle },
                }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "right-content-container" },
          [_vm.permissionReady ? _c("router-view") : _vm._e()],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewDialogVisible,
            "destroy-on-close": "",
            fullscreen: "",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewDialogVisible = $event
            },
          },
        },
        [
          _c("pre-view", {
            key: _vm.previewKey,
            attrs: { "preview-qrcode": true },
          }),
        ],
        1
      ),
      _c("template-create", {
        ref: "templateCreate",
        attrs: { "form-key": _vm.projectKey },
      }),
      _c("history", {
        ref: "history",
        attrs: { historyData: _vm.historyData },
        on: { toHistoryDetail: _vm.toHistoryDetail },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.detailDialogVisible,
            "destroy-on-close": "",
            fullscreen: "",
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialogVisible = $event
            },
          },
        },
        [
          _c("detail", {
            key: _vm.detailInfo.id,
            ref: "detailRef",
            attrs: { detailInfo: _vm.detailInfo },
            on: {
              goBack: function () {
                return (_vm.detailDialogVisible = false)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }